import { render, staticRenderFns } from "./CourseNameEdit.vue?vue&type=template&id=38111154&scoped=true&lang=pug"
import script from "./CourseNameEdit.vue?vue&type=script&lang=js"
export * from "./CourseNameEdit.vue?vue&type=script&lang=js"
import style0 from "./CourseNameEdit.vue?vue&type=style&index=0&id=38111154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38111154",
  null
  
)

export default component.exports